import type { Ctx } from "../../types";
import { Query } from "gg-wf-scripts";
import { applyListParams } from "../_shared";
import { decorateJob, jobsListSortMap, jobsSearchCols } from "./_helpers";

export const jobs_list: Query<Ctx> = async ({ sb }, params) => {
  let query = sb.from("v_jobs_list").select("*");
  query = applyListParams(query, params, {
    search: jobsSearchCols,
    sort: {
      map: jobsListSortMap,
      default: [
        { column: "start_date", ascending: false },
        { column: "start_time", ascending: false },
      ],
    },
  });
  const { data } = await query;
  if (!data) return [];
  return data.map(decorateJob);
};
